import './book-modal.scss';
import { ReactNode } from 'react';

interface BookContainerProps {
  infoComponent: ReactNode;
  formComponent: ReactNode;
}

const BookModalComponent = (props: BookContainerProps) => {
  return (
    <div className="book-modal">
      {props.infoComponent}
      {props.formComponent}
    </div>
  );
};

export default BookModalComponent;
